import { flatten, get, isNumber, set, uniq, round } from "lodash"

import gameConfigurationField from "../../../Edit/formly/gameConfigurations"
import epromConfigurationField from "../../../Edit/formly/epromConfigurations"
import machineServer from "../../../../Server/index"
import fieldHelpers from "../../../../../../ui-formly/fieldHelpers/index"

import authService from "../../../../../../user/authorization/authService"

import { vsName as ServerUtilityName } from "../../../../../../records/server/serverUtility"

formly.$inject = [authService.vsName, "dateFilter", "$timeout"]
function formly(authService, dateFilter, $timeout) {
  const fields = [
    {
      key: "ConversionTypeId",
      name: "ConversionTypeId",
      type: "selectAsync",
      templateOptions: {
        label: "Conversion Type",
        required: true,
        showAddButton: authService.hasPermission("machineEdit"),
        query: [
          machineServer.vsName,
          function (server) {
            return function (search) {
              return server.conversionTypeQuery({
                NameContains: search,
                Skip: 0,
                Take: 25,
                OrderBy: "Name",
              })
            }
          },
        ],
        saveNewItem: [
          machineServer.vsName,
          function (server) {
            return function (name) {
              return server.conversionTypeSave({
                Name: name,
              })
            }
          },
        ],
        getDefaultItem: function (model) {
          return {
            Id: model.ConversionTypeId,
            Name: model.ConversionTypeName,
          }
        },
        updateNameProp: "ConversionTypeName",
      },
    },
    fieldHelpers.headerField({
      key: "DateLocationHeader",
      headerText: "Date/Location",
    }),
    fieldHelpers.columnLayout(
      [
        {
          ...fieldHelpers.simpleDateField({
            key: "Date",
            label: "Date",
            required: true,
          }),
          className: "attention",
        },
        readonlyDateField(dateFilter, {
          key: "ManufacturedDate",
          label: "Manufactured Date",
        }),
        fieldHelpers.simpleDateField({
          key: "InServiceDate",
          label: "In Service Date",
        }),
      ],
      4
    ),
    fieldHelpers.columnLayout(
      [
        {
          key: "PropertyId",
          name: "PropertyId",
          type: "selectAsync",
          templateOptions: {
            label: "Property",
            required: true,
            query: [
              ServerUtilityName,
              function (serverUtility) {
                return function (search) {
                  return serverUtility.lookupQuery({
                    url: "/api/properties",
                    search,
                  })
                }
              },
            ],
            getDefaultItem: function (model) {
              return {
                Id: model.PropertyId,
                Name: model.PropertyName,
              }
            },
            updateNameProp: "PropertyName",
          },
        },
        {
          key: "MachineAreaId",
          name: "MachineAreaId",
          type: "selectAsync",
          className: "attention",
          templateOptions: {
            label: "Area",
            required: true,
            showAddButton: authService.hasPermission("machineEdit"),
            query: [
              machineServer.vsName,
              function (server) {
                return function (search) {
                  return server.machineAreaQuery({
                    NameContains: search,
                    Skip: 0,
                    Take: 25,
                    OrderBy: "Name",
                  })
                }
              },
            ],
            saveNewItem: [
              machineServer.vsName,
              function (server) {
                return function (name) {
                  return server.machineAreaSave({
                    Name: name,
                  })
                }
              },
            ],
            getDefaultItem: function (model) {
              return {
                Id: model.MachineAreaId,
                Name: model.MachineAreaName,
              }
            },
            updateNameProp: "MachineAreaName",
          },
        },
        { ...locationField("Section"), className: "attention" },
        { ...locationField("Bank"), className: "attention" },
        { ...locationField("Slot"), className: "attention" },
        {
          key: "MachineBankConfigId",
          name: "MachineBankConfigId",
          type: "selectAsync",
          className: "attention",
          templateOptions: {
            label: "Bank Config",
            required: true,
            showAddButton: authService.hasPermission("machineEdit"),
            query: [
              machineServer.vsName,
              function (server) {
                return function (search) {
                  return server.machineBankConfigQuery({
                    NameContains: search,
                    Skip: 0,
                    Take: 25,
                    OrderBy: "Name",
                  })
                }
              },
            ],
            saveNewItem: [
              machineServer.vsName,
              function (server) {
                return function (name) {
                  return server.machineBankConfigSave({
                    Name: name,
                  })
                }
              },
            ],
            getDefaultItem: function (model) {
              return {
                Id: model.MachineBankConfigId,
                Name: model.MachineBankConfigName,
              }
            },
            updateNameProp: "MachineBankConfigName",
          },
        },
      ],
      4
    ),
    fieldHelpers.headerField({
      key: "EGMInformation",
      headerText: "EGM Information",
    }),
    fieldHelpers.columnLayout(
      [
        fieldHelpers.simpleReadonlyField({
          key: "ManufacturerName",
          label: "Manufacturer",
        }),
        fieldHelpers.simpleReadonlyField({
          key: "SerialNumber",
          label: "SerialNumber",
        }),
        {
          key: "SlotNumber",
          name: "SlotNumber",
          type: "input",
          className: "attention",
          templateOptions: {
            label: "Asset Number",
          },
        },
        {
          key: "Status",
          name: "Status",
          type: "selectAsync",
          templateOptions: {
            required: true,
            label: "Status",
            query: [
              machineServer.vsName,
              function (server) {
                return function (search) {
                  return server.statusGet({
                    NameContains: search,
                  })
                }
              },
            ],
            getDefaultItem: function (model) {
              return {
                Id: model.Status,
                Name: model.Status,
              }
            },
          },
        },
      ],
      4
    ),
    fieldHelpers.columnLayout(
      [
        boolField({ key: "CameraCoverage", label: "Camera Coverage" }),
        {
          ...boolField({ key: "FreePlayEnabled", label: "Free Play Enabled" }),
          className: "attention",
        },
        fieldHelpers.simpleReadonlyField({
          key: "CabinetTypeName",
          label: "Cabinet Type",
        }),
        fieldHelpers.simpleReadonlyField({
          key: "ModelNumberName",
          label: "Model",
        }),
        fieldHelpers.simpleReadonlyField({
          key: "DisplayTypeName",
          label: "Display Type",
        }),
        fieldHelpers.simpleReadonlyField({
          key: "NumberOfReels",
          label: "Number of reels",
        }),
      ],
      4
    ),
    fieldHelpers.headerField({
      key: "GameConfigurations",
      headerText: "Game Configurations",
    }),
    fieldHelpers.columnLayout(
      [fieldHelpers.simpleStringField({ key: "GameName", label: "Game Name" })],
      1
    ),
    gameConfigurationField(authService),
    fieldHelpers.columnLayout(
      [
        {
          key: "MultiGame",
          type: "checkbox",
          templateOptions: {
            label: "Multi Game?",
            readonly: true,
          },
          watcher: {
            type: "$watchCollection",
            expression: function (field, scope) {
              const themeIds = get(scope, "model.GameConfigurations").map(
                (gameConfiguration) => gameConfiguration.ThemeId
              )
              return uniq(themeIds)
            },
            listener: function (field, newValue, oldValue, scope) {
              const valuePath = `model.${field.key}`
              field.templateOptions.readonly = false
              $timeout(() => {
                set(scope, valuePath, newValue.length > 1)
                field.templateOptions.readonly = true
              }, 0)
            },
          },
          className: "attention",
        },
        {
          key: "MultiDenom",
          type: "checkbox",
          templateOptions: {
            label: "Multi Denomination?",
            readonly: true,
          },
          watcher: {
            type: "$watchCollection",
            expression: function (field, scope) {
              const denominationIds = get(
                scope,
                "model.GameConfigurations"
              ).map((gameConfiguration) => gameConfiguration.DenominationId)
              return uniq(denominationIds)
            },
            listener: function (field, newValue, oldValue, scope) {
              const valuePath = `model.${field.key}`
              field.templateOptions.readonly = false
              $timeout(() => {
                set(scope, valuePath, newValue.length > 1)
                field.templateOptions.readonly = true
              }, 0)
            },
          },
          className: "attention",
        },
        {
          key: "Poker",
          type: "checkbox",
          templateOptions: {
            label: "Poker",
            defaultIfNull: false,
          },
        },
      ],
      4
    ),
    fieldHelpers.headerField({
      key: "GameMath",
      headerText: "Game Configuration/Game Math",
    }),
    fieldHelpers.columnLayout(
      [
        fieldHelpers.simplePercentageField({
          key: "ParSheetHold",
          label: "Par Sheet Hold",
          step: 0.001,
          min: 0,
          max: 100,
        }),
        boolField({ key: "Progressive" }),
        {
          ...fieldHelpers.simplePercentageField({
            key: "SystemHold",
            label: "System Hold",
            step: 0.001,
            min: 0,
            max: 100,
          }),
          className: "attention",
        },
        {
          ...boolField({ key: "FourPercent", label: "4%" }),
          className: "attention",
        },
        {
          ...fieldHelpers.simplePercentageField({
            key: "MinRtp",
            label: "Min RTP%",
            step: 0.001,
            min: 0,
            max: 100,
          }),
          className: "attention",
        },
        {
          ...fieldHelpers.simplePercentageField({
            key: "MaxRtp",
            label: "Max RTP%",
            step: 0.001,
            min: 0,
            max: 100,
          }),
          className: "attention",
        },
        {
          key: "AverageRTP",
          type: "input",
          templateOptions: {
            label: "Average RTP%",
            type: "number",
            readonly: true,
            step: 0.001,
          },
          watcher: {
            expression: function (field, scope) {
              const minRtp = get(scope, "model.MinRtp")
              const maxRtp = get(scope, "model.MaxRtp")

              if (!isNumber(minRtp) || !isNumber(maxRtp)) {
                return undefined
              }

              const average = (minRtp + maxRtp) / 2

              return round(average, 3)
            },
            listener: function (field, newValue, oldValue, scope) {
              const valuePath = `model.${field.key}`
              set(scope, valuePath, newValue)
            },
          },
        },
        boolField({
          key: "AdjustedByCompliance",
          label: "Adjusted By Compliance",
        }),
      ],
      4
    ),
    fieldHelpers.headerField({
      key: "ProgressiveInformation",
      headerText: "Progressive Information",
    }),
    fieldHelpers.columnLayout(
      [
        boolField({
          key: "ProgressiveController",
          label: "Progressive Controller",
        }),
        fieldHelpers.simpleStringField({ key: "Position", label: "Position" }),
        fieldHelpers.simpleStringField({
          key: "ProgressiveSerialNumber",
          label: "Progressive Serial#",
        }),
      ],
      4
    ),
    fieldHelpers.headerField({
      key: "LeasedInformation",
      headerText: "Leased Information",
    }),
    fieldHelpers.columnLayout(
      [
        { ...boolField({ key: "Leased" }), className: "attention" },
        boolField({ key: "LeasedSoftware", label: "Leased Software" }),

        {
          ...fieldHelpers.simpleStringField({
            key: "SpecialPUPD",
            label: "Specialty PUPD",
          }),
          className: "attention",
        },
      ],
      4
    ),
    fieldHelpers.headerField({ key: "EPROMs", headerText: "EPROMs" }),
    epromConfigurationField(authService),
    fieldHelpers.headerField({
      key: "PlayerTracking",
      headerText: "Limit Settings",
    }),
    fieldHelpers.columnLayout(
      [
        fieldHelpers.simpleCurrencyField({
          key: "CreditLimit",
          label: "Credit Limit",
          min: 0,
          step: 0.01,
        }),
        fieldHelpers.simpleCurrencyField({
          key: "BillLimit",
          label: "Bill Limit",
          min: 0,
          step: 0.01,
        }),
        fieldHelpers.simpleCurrencyField({
          key: "JackpotLimit",
          label: "Jackpot Limit",
          min: 0,
          step: 0.01,
        }),
      ],
      4
    ),
    fieldHelpers.headerField({
      headerText: "Marketing",
      key: "MarketingSection",
    }),
    fieldHelpers.columnLayout(
      [
        boolField({
          key: "FirstToFloor",
          name: "FirstToFloor",
          label: "First to Floor",
        }),
        boolField({
          key: "FirstToTucson",
          name: "FirstToTucson",
          label: "First to Tucson",
        }),
        boolField({
          key: "FirstToArizona",
          name: "FirstToArizona",
          label: "First to Arizona",
        }),
      ],
      4
    ),
    fieldHelpers.headerField({ key: "FilesSection", headerText: "Files" }),
    fieldHelpers.columnLayout(
      [
        {
          key: "ParSheet",
          name: "ParSheet",
          type: "fileUploadSingle",
          templateOptions: {
            label: "Par Sheet",
          },
        },
        {
          key: "SlotServiceRequestForm",
          name: "SlotServiceRequestForm",
          type: "fileUploadSingle",
          templateOptions: {
            label: "Slot Service Request Form",
          },
        },
        {
          key: "TheoreticalHoldWorksheet",
          name: "TheoreticalHoldWorksheet",
          type: "fileUploadSingle",
          templateOptions: {
            label: "Theoretical Hold Worksheet",
          },
        },
        {
          key: "ShipmentNotification",
          name: "ShipmentNotification",
          type: "fileUploadSingle",
          templateOptions: {
            label: "Shipment Notification",
          },
        },
        {
          key: "IntConfigSheet",
          name: "IntConfigSheet",
          type: "fileUploadSingle",
          templateOptions: {
            label: "Int Config Sheet",
          },
        },
      ],
      4
    ),
    {
      key: "Files",
      name: "Files",
      type: "fileUpload",
      templateOptions: {
        label: " ",
        noFilesText: "No additional files",
      },
    },
    fieldHelpers.headerField({ key: "NotesHeader", headerText: "Notes" }),
    fieldHelpers.columnLayout(
      [
        fieldHelpers.textAreaField({
          key: "Notes",
          label: " ",
        }),
      ],
      1
    ),
  ]

  return flatten(fields, false)

  function locationField(fieldName, label) {
    return {
      key: fieldName,
      name: fieldName,
      type: "input",
      templateOptions: {
        label: label || fieldName,
      },
      expressionProperties: {
        "templateOptions.required": isFloorStatus(fieldName),
      },
    }
  }

  function isFloorStatus(fieldName) {
    return function ($viewValue, $modelValue, scope) {
      var machine = scope.model

      var modelController = scope.form[fieldName]
      var floorStatus = machine.Status === "Floor"

      if (modelController && !floorStatus) {
        modelController.$setValidity("required", true)
      }

      return floorStatus
    }
  }
}

function boolField({ key, name, label }) {
  return {
    key,
    name: name || key,
    type: "checkbox",
    templateOptions: {
      label: label || key,
      defaultIfNull: false,
    },
  }
}

function readonlyDateField(dateFilter, { key, label }) {
  return {
    type: "readonly",
    key,
    templateOptions: {
      label,
    },
    formatters: [(value) => dateFilter(value)],
  }
}

export default formly
